var map = {
	"./AddTokens.svg": 72758,
	"./GiveReraffle.svg": 22477,
	"./GiveTokens.svg": 68478,
	"./Give_Nothing.svg": 11582,
	"./Give_Slot.svg": 84995,
	"./Plus.svg": 79819,
	"./Vectorcoins.svg": 39180,
	"./Vectortokens.svg": 64680
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25853;